import { render, staticRenderFns } from "./ProductArchieve.vue?vue&type=template&id=00db3f42&scoped=true"
import script from "./ProductArchieve.vue?vue&type=script&lang=js"
export * from "./ProductArchieve.vue?vue&type=script&lang=js"
import style0 from "./ProductArchieve.vue?vue&type=style&index=0&id=00db3f42&prod&lang=sass&scoped=true"
import style1 from "./ProductArchieve.vue?vue&type=style&index=1&id=00db3f42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db3f42",
  null
  
)

export default component.exports